module.exports = __webpack_public_path__ + "img/marca1.0d074c6d.png";